import Dates from 'components/Dates';
import { SchoolJobDataFamily } from 'types/dacum/schoolManagement';

export const columns = [
  {
    heading: 'Job Family',
    props: 'jobFamilyName',
    sortable: true,
    active: true,
    disabled: false,
    id: 'jobFamilyName'
  },
  {
    heading: 'School ID',
    props: 'msSchoolCompetencyManagementID',
    sortable: true,
    active: false,
    disabled: false,
    id: 'msSchoolCompetencyManagementID'
  },
  {
    heading: 'School Name',
    props: 'schoolName',
    sortable: true,
    active: true,
    disabled: false,
    id: 'schoolName'
  },
  {
    heading: 'Job Family ID',
    props: 'jobFamilyID',
    sortable: true,
    active: false,
    disabled: false,
    id: 'jobFamilyID'
  },
  {
    heading: 'Created Date',
    props: ({ dateIn }: SchoolJobDataFamily) => <Dates date={dateIn} />,
    sortable: true,
    active: true,
    disabled: false,
    id: 'dateIn'
  },
  {
    heading: 'Created By',
    props: 'userIn',
    sortable: true,
    active: true,
    disabled: false,
    id: 'userIn'
  },
  {
    heading: 'Action',
    props: 'action',
    sortable: false,
    active: true,
    disabled: false,
    id: 'action'
  }
];
